import { Table, TableCell, typographyV2 } from '@toggle/design-system';
import { NumericalCellValueStyle } from '@toggle/helpers';
import styled, { css } from 'styled-components';

const colors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish)',
  [NumericalCellValueStyle.Neutral]: 'var(--text-default)',
};

const backgroundColors = {
  [NumericalCellValueStyle.Positive]: 'var(--viz-bullish-soft)',
  [NumericalCellValueStyle.Negative]: 'var(--viz-bearish-soft)',
  [NumericalCellValueStyle.Neutral]: 'transparent',
};

export const Container = styled.div`
  position: relative;
`;
export const MovementTable = styled(Table)`
  background-color: var(--background-default);
  td {
    box-shadow: none;
  }
  thead th {
    border-bottom: none;
    ${typographyV2.bodyXs};
    color: var(--text-soft);
    text-align: center;
  }
`;

export const BackgroundVector = styled.span`
  position: absolute;
  z-index: 0;
  right: 0px;
  bottom: 0;
  height: 221px;
  width: 120px;
  background-image: url('/terminal/static/images/price/priceMovementVector.png');
  background-repeat: no-repeat;
`;

export const Label = styled.span`
  position: absolute;
  right: -62px;
  bottom: 105px;
  transform: rotate(90deg);
  background-color: var(--surface-neutral);
  border-radius: 0 4px 4px 0;
  width: 137px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  z-index: 1;
  ${typographyV2.bodyXs}
  padding: 0 7px 0 7px;
`;
export const MovementBodyCell = styled(TableCell)<{
  $numericalStyle: NumericalCellValueStyle;
  $index: number[];
}>`
  position: relative;
  ${({ $numericalStyle, $index }) => {
    const [row, column] = $index;
    return css`
      color: ${colors[$numericalStyle]};
      text-align: center;
      background-color: ${backgroundColors[$numericalStyle]};
      ${$numericalStyle === NumericalCellValueStyle.Neutral &&
      `
            box-shadow: none;
            border-bottom: none;
            `}
      ${(row === 0 || row === 3) &&
      'border-bottom: 1px solid var(--border-default);'}
      ${row > 0 &&
      row <= 3 &&
      column === 6 &&
      'border-right: 1px solid var(--border-default);'}
    `;
  }}
  z-index : 1;
`;

export const MovementColumnLabel = styled(MovementBodyCell)`
  text-align: left;
  width: 120px;
  ${typographyV2.bodyXs}
`;
